// Sticky Kontaktbox (Textbaustein in der globalen Area `sticky_contact`)
// - Desktop: Hover/Focus klappt die Pille per CSS auf (kein JS nötig).
// - Touch/Tastatur: Tap auf den Button togglet .is-open (Esc / Klick außerhalb schließt).
// - Reveal-Gating: auf der Startseite erst einblenden, wenn die Header-Animation
//   startet (Event 'header:animationstart' aus header.js); sonst sofort.
// Die Links/Telefon/E-Mail stehen als fertige hrefs direkt im Textbaustein-HTML.

import { isHomepage } from './pageContext.js';

export function initStickyContact() {
  const box = document.querySelector('.js-stickyContact');
  if (!box) return;

  const toggle = box.querySelector('.js-stickyContactToggle');

  // ── Toggle (Touch/Tastatur) ───────────────────────────────────────────────
  if (toggle) {
    const isOpen = () => box.classList.contains('is-open');

    const open = () => {
      box.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', 'Kontakt schließen');
    };

    const close = () => {
      box.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Kontakt öffnen');
    };

    toggle.addEventListener('click', () => (isOpen() ? close() : open()));

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && isOpen()) {
        close();
        toggle.focus();
      }
    });

    document.addEventListener('click', (e) => {
      if (isOpen() && !box.contains(e.target)) close();
    });
  }

  // ── Reveal-Gating ─────────────────────────────────────────────────────────
  const reveal = () => box.classList.add('is-visible');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // Spiegelt exakt die Bedingung, unter der header.js die Animation armiert.
  const waitForHeader = isHomepage() && !reducedMotion;

  if (waitForHeader) {
    window.addEventListener('header:animationstart', reveal, { once: true });
  } else {
    requestAnimationFrame(reveal);
  }
}
